var webpSuffix = '_.webp';
var ossWebpSuffix = '.webp';
export default function (isOSSImg) {
  if (isOSSImg) {
    return ossWebpSuffix;
  } else {
    return webpSuffix;
  }
}